import React, { Fragment } from "react";

import { VaultCardLoader } from "./CardLoader";

interface SliderLoaderProps {
  rows?: 1 | 2;
}
export default function SliderLoader({ rows = 2 }: SliderLoaderProps) {
  return (
    <div className="grid grid-cols-1 gap-x-8 gap-y-6 md:grid-cols-2 xl:grid-cols-3">
      <VaultCardLoader />
      <VaultCardLoader className="hidden md:!block" />
      <VaultCardLoader className="hidden lg:!block" />
      {rows === 2 && (
        <Fragment>
          <VaultCardLoader className="hidden lg:!block" />
          <VaultCardLoader className="hidden xl:!block" />
          <VaultCardLoader className="hidden xl:!block" />
        </Fragment>
      )}
    </div>
  );
}
